/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_summary_details_empty_license_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `This item doesn't have a defined license.`
};

const fr_summary_details_empty_license_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `Cet élément n'a pas de licence définie.`
};

const de_summary_details_empty_license_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `Für dieses Element ist keine Lizenz definiert.`
};

const es_summary_details_empty_license_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `Este artículo no tiene una licencia definida.`
};

const it_summary_details_empty_license_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `Questo articolo non ha una licenza definita.`
};

const ar_summary_details_empty_license_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `هذا العنصر ليس لديه ترخيص محدد.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const summary_details_empty_license_text30 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.summary_details_empty_license_text30(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("summary_details_empty_license_text30", locale)
	if (locale === "en") return en_summary_details_empty_license_text30(inputs)
	if (locale === "fr") return fr_summary_details_empty_license_text30(inputs)
	if (locale === "de") return de_summary_details_empty_license_text30(inputs)
	if (locale === "es") return es_summary_details_empty_license_text30(inputs)
	if (locale === "it") return it_summary_details_empty_license_text30(inputs)
	return ar_summary_details_empty_license_text30(inputs)
};
export { summary_details_empty_license_text30 as "SUMMARY_DETAILS_EMPTY_LICENSE_TEXT" }